export const SET_DEFAULT_SETTINGS = 'SET_DEFAULT_SETTINGS';
